import { Box, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import ArrowLeftIcon from 'wix-ui-icons-common/ArrowLeft';
import ArrowRightIcon from 'wix-ui-icons-common/ArrowRight';

import { DATA_HOOKS } from '../../../dataHooks';
import { isRTL } from '../../../utils/internationalization';
import { pushUrl } from '../../InnerLink';

import css from './index.module.scss';

export const BackButton: FunctionComponent = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const isRTLLanguage = isRTL(locale);

  const onClick = async () => {
    await pushUrl(`/${locale}`);
  };

  return (
    <Box
      direction="vertical"
      className={css.backButtonWrapper}
      dataHook={DATA_HOOKS.MY_PROFILE_BACK_TO_HC}
    >
      <TextButton
        weight="normal"
        size="small"
        onClick={onClick}
        prefixIcon={isRTLLanguage ? <ArrowRightIcon /> : <ArrowLeftIcon />}
        dataHook={DATA_HOOKS.CATEGORY_BACK_BTN}
        className={css.backButton}
      >
        {t('help.center')}
      </TextButton>
    </Box>
  );
};
